export default __webpack_public_path__ + "static/media/382.52e95ab4.png";